function tearTheBagIconAdd(){
	const searchItems = document.querySelectorAll('.c-post__materials');
	searchItems.forEach((item) => {
		const me = item.closest('.c-post');
		let isTear = false;
		let isNottear = false;
		const text = item.innerText;
		item.closest('.c-post').querySelector('.c-post__body .c-hdr-a').insertAdjacentHTML('beforeend', '<div class="c-post__bag-state"></div>')

		const isTearHtml = '<span class="c-icon c-icon--is-tear"></span>';
		const isNotTearHtml = '<span class="c-icon c-icon--is-not-tear"></span>';

		const kayanoyaRegexp = /茅乃舎だし.*/g;
		const kayanoyaMatches = text.match(kayanoyaRegexp);
		if(kayanoyaMatches) {
			kayanoyaMatches.forEach((str)=> {
				if(str.includes('袋を破って')) {
					if(!isTear) {
						me.classList.add('is-tear');
						me.querySelector('.c-post__body .c-post__bag-state').insertAdjacentHTML('beforeend', isTearHtml);
						isTear = true;
					}
				} else {
					if(!isNottear) {
						me.classList.add('is-not-tear');
						me.querySelector('.c-post__body .c-post__bag-state').insertAdjacentHTML('beforeend', isNotTearHtml);
						isNottear = true;
					}
				}
			});
		}

		const yasaiRegexp = /野菜だし.*/g;
		const yasaiMatches = text.match(yasaiRegexp);
		if(yasaiMatches) {
			yasaiMatches.forEach((str)=> {
				if(str.includes('袋を破って')) {
					if(!isTear) {
						me.classList.add('is-tear');
						me.querySelector('.c-post__body .c-post__bag-state').insertAdjacentHTML('beforeend', isTearHtml);
						isTear = true;
					}
				} else {
					if(!isNottear) {
						me.classList.add('is-not-tear');
						me.querySelector('.c-post__body .c-post__bag-state').insertAdjacentHTML('beforeend', isNotTearHtml);
						isNottear = true;
					}
				}
			});
		}
	});
};

export {tearTheBagIconAdd};
